import { render, staticRenderFns } from "./addGroups.vue?vue&type=template&id=32de91ef"
import script from "./addGroups.vue?vue&type=script&lang=js"
export * from "./addGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports